import { useMemo } from 'react';
import { useSignalCustomFieldsAsFilterableFields } from './custom-fields';
import { useSignalNativeFieldsAsFilterableFields } from './default-fields';

export const useSignalFieldsAsFilterableField = () => {
  const { fields: nativeFields, loading: nativeFieldsLoading } =
    useSignalNativeFieldsAsFilterableFields();
  const { fields: customFields, loading: customFieldsLoading } =
    useSignalCustomFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: nativeFields.concat(
        customFields.filter((field) => field.fieldName !== 'Reason'),
      ),
      loading: nativeFieldsLoading || customFieldsLoading,
    }),
    [customFields, customFieldsLoading, nativeFields, nativeFieldsLoading],
  );
};

export const useSignalFieldsAsFilterableFieldWithReason = () => {
  const { fields: nativeFields, loading: nativeFieldsLoading } =
    useSignalNativeFieldsAsFilterableFields();
  const { fields: customFields, loading: customFieldsLoading } =
    useSignalCustomFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: nativeFields.concat(customFields),
      loading: nativeFieldsLoading || customFieldsLoading,
    }),
    [customFields, customFieldsLoading, nativeFields, nativeFieldsLoading],
  );
};
